<template>
  <div class="page-listings">

    <rga-tour v-if="$store.state.tour & !loading && filteredRGAs.length" />

    <section
      v-if="loading"
      data-v-5a90ec03
      class="pt-5 pb-3 pixelsbggrid bs-shadow mobile-top"
      style="min-height: 260px"
    >
      <div data-v-5a90ec03 class="container">
        <h1 class="text-white mb0 lh1">Loading RGAs....</h1>
        <br />
        <div class="hollow-dots-spinner">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
    </section>

    <section v-else class="pt-5 pb-3 pixelsbggrid bs-shadow mobile-top">
      <div data-v-5a90ec03 class="container">


        <div class="input-wrap">
        <input
          id="RGA-step-1"
          class="top-search mt0"
          type="text"
          placeholder="Search for RGA by order number, RGA number, or status"
          style="padding: 15px;"
          v-model="searchValue"
          @keyup.enter.prevent="searchQuery"
        />

        <button
            :class="[showButton ? 'clear-btn' : 'clear-hide']"
            @click="clearSearch"
            type="button"
            class="d-flex align-items-center pr-3 clear-btn"
          >
            <svg
              class="w-4 h-4 text-[#429da8] hover:text-[#1E3040]"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path
                d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
              ></path>
            </svg>
          </button>
        </div>


        
        <div class="search-btns">
          <div class="left-side">
            <div id="RGA-step-2" class="ac-select">
              <select
                class="form-control"
                id="exampleFormControlSelect1"
                v-model="acFilter"
              >
                <option :value="null" selected class="all-contractors">
                  Area Contractor
                </option>
                <option v-for="ac in acs" :key="ac.acid" :value="ac.acid">
                  {{ " " + ac.acName + " (" + ac.acid + ")" }}
                </option>
                <!--
				>{{ " " + ac.acName + " (" + ac.acid + ")" }}</option>
                -->
              </select>
            </div>

            <div class="dates" id="dates" style="margin-right: 14px;">

              <VueDatePicker v-model="startDate" 
              input-class-name="dp-custom-input"
              :enable-time-picker="false" 
              format="MMM dd yyyy"
                placeholder="From Date"
                wrapperClass="pickthedate"
                :typeable="true"
                style="padding-right: 10px;"
                ></VueDatePicker>


                <VueDatePicker v-model="endDate" 
                id="RGA-step-3"
                input-class-name="dp-custom-input"
                :enable-time-picker="false" 
                format="MMM dd yyyy"
                placeholder="To Date"
                wrapperClass="pickthedate"
                :typeable="true"
                ></VueDatePicker>


                <!--
              <datepicker
                format="MMM dd yyyy"
                placeholder="From Date"
                v-model="startDate"
                wrapperClass="pickthedate"
                :typeable="true"
              ></datepicker>


              <datepicker
                id="RGA-step-3"
                format="MMM dd yyyy"
                placeholder="To Date"
                v-model="endDate"
                wrapperClass="pickthedate"
                :typeable="true"
              ></datepicker>
                -->
            </div>
          </div>

          <div class="right-side">
            <button
              v-if="
                (searchValue || startDate || endDate || acFilter || searchStarted) &&
                !searchStarted
              "
              @click.prevent="searchQuery"
              class="search"
            >
              <span class="material-icons">search</span>
              {{ " " }} Search
            </button>
            <button v-else class="search" disabled>
              <span class="material-icons">search</span>
              {{ " " }} Search
            </button>
            <!--
            <button
              v-if="searchValue || startDate || endDate || acFilter"
              @click="clearSearch"
              class="clear"
            >
              <span class="material-icons">find_replace</span>
              {{ " " }} Clear
            </button>
            <button v-else disabled class="clear">
              <span class="material-icons">find_replace</span>
              {{ " " }} Clear
            </button>
            -->
          </div>
        </div>

        <!--
        <div class="date-area">
          <vc-calendar mode="range" v-model="attributes" :max-date="new Date()" is-inline />
        </div>
        -->
      </div>
    </section>

    <div :class="loading == false && !filteredRGAs.length ? 'message-bg' : ''">
      <div class="container">
        <div class="row">
          <div
            v-if="loading == true"
            class="col-xs-12 col-sm-12 col-12 col-lg-12"
          >
            <div class="flex-box-wrap">
              <div class="flex-internal">
                <atom-spinner
                  :animation-duration="1000"
                  :size="40"
                  :color="'#575757'"
                />
                <p>Loading......</p>
              </div>
            </div>
          </div>

          <div
            v-else-if="loading == false && !filteredRGAs.length"
            class="col-xs-12 col-sm-12 col-12 col-lg-12 flexVHcenter"
          >
            <div>
              <h2 style="margin: 30px 20px; color: #429da8; font-weight: 400">
                It looks like there are no RGAs to show...
              </h2>
              <img src="@/assets/img/nothingHere.svg" style="width: 100%" />
            </div>
          </div>

          <div v-else class="col-xs-12 col-sm-12 col-12 col-lg-12">
            <div
              class="
                rga-header
                d-flex
                align-items-center
                p-3
                mt-3
                mb10
                rounded
                box-shadow
              "
            >
              <p class="mrauto mb0">
                Page {{ currPage }} of
                {{ Math.ceil(this.filteredRGAs.length / 100) }}
              </p>
              <div class="pag-wrapper mlauto">
                <div id="RGA-step-4" class="nav-btns">
                  <button v-if="this.currPage === 1" disabled>
                    <i class="material-icons">keyboard_arrow_left</i> Back
                  </button>

                  <button v-else @click.prevent="setPage(currPage - 1)">
                    <i class="material-icons">keyboard_arrow_left</i> Back
                  </button>

                  <button
                    v-if="
                      this.currPage === this.totalPage ||
                      this.currPage == Math.ceil(this.filteredRGAs.length / 100)
                    "
                    disabled
                  >
                    Next
                    <i class="material-icons">keyboard_arrow_right</i>
                  </button>

                  <button v-else @click.prevent="setPage(currPage + 1)">
                    Next
                    <i class="material-icons">keyboard_arrow_right</i>
                  </button>
                </div>

                <!--
          <p class="mtauto" v-if="search.length">Results are being filtered</p>
          <p class="mtauto" v-else>Page {{currPage}} of {{ totalPage }} </p>
          <div class="nav-btns">

              <button v-if="this.currPage === 1" disabled><i class="material-icons">keyboard_arrow_left</i> Back</button>

              <button v-else @click.prevent="setPage(currPage-1)"><i class="material-icons">keyboard_arrow_left</i> Back</button>

              <button v-if="this.currPage === this.totalPage" disabled>Next <i class="material-icons">keyboard_arrow_right</i></button>

              <button v-else @click.prevent="setPage(currPage+1)">Next <i class="material-icons">keyboard_arrow_right</i></button>

          </div>
              --></div>
            </div>

            <div>
              <div class="listing">
                <!--
          <div v-for="rga in rgas" :key="rga.Tid">
              -->
                <h2 class data-config-id="header">
                  Return Goods Authorization
                </h2>
                <div class="rfr table-responsive">
                  <table class="table-striped table-bordered" style="display: table; min-width: 100%">
  <thead>
    <tr>
      <th
        v-for="c in rgaColumns"
        :key="c.key"
        scope="col"
        class="table-link"
        :class="[c.cls, { 'column-active': columnSort === c.key }]"
        @click="sortCol(c.key)"
      >
        <span class="th-inner">
          <span>{{ c.label }}</span>
          <i class="material-icons carrot-icon" :class="{ 'carrot-icon-active': columnSort === c.key }">filter_list</i>
        </span>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      v-for="(rga, index) in filteredRGAs.slice(pageStart, pageStart + countOfPage)"
      :key="rga.rgaid"
    >
      <td class="id">
        <router-link :to="'/rga-details/' + rga.rgaid" :id="index === 0 ? 'RGA-step-5' : null">
          {{ rga.rgaid }}
        </router-link>
      </td>
      <td class="order">
        <router-link v-if="rga.orderNo" :to="'/order-details/' + rga.orderNo" :id="index === 0 ? 'RGA-step-6' : null">
          {{ rga.orderNo }}
        </router-link>
        <span v-else class="muted">—</span>
      </td>
      <td class="ac">{{ rga.acName }}<span class="acid">({{ rga.acid }})</span></td>
      <td class="person" :class="{ muted: !rga.requestedByUser }">{{ rga.requestedByUser || "—" }}</td>
      <td class="date">{{ rga.submitDate ? $moment(rga.submitDate).format("MM-DD-YYYY") : "—" }}</td>
      <td>
        <span :class="['status-pill', statusClass(rga.status)]">{{ rga.status || "Pending" }}</span>
      </td>
    </tr>
  </tbody>
</table>
                </div>
                <!-- card -->
              </div>
            </div>

            <div
              class="
                rga-header
                d-flex
                align-items-center
                p-3
                mb-3
                mt10
                rounded
                box-shadow
              "
            >
              <p class="mrauto mb0">
                Page {{ currPage }} of
                {{ Math.ceil(this.filteredRGAs.length / 100) }}
              </p>
              <div class="pag-wrapper mlauto">
                <div class="nav-btns">
                  <button v-if="this.currPage === 1" disabled>
                    <i class="material-icons">keyboard_arrow_left</i> Back
                  </button>

                  <button v-else @click.prevent="setPage(currPage - 1)">
                    <i class="material-icons">keyboard_arrow_left</i> Back
                  </button>

                  <button
                    v-if="
                      this.currPage === this.totalPage ||
                      this.currPage == Math.ceil(this.filteredRGAs.length / 100)
                    "
                    disabled
                  >
                    Next
                    <i class="material-icons">keyboard_arrow_right</i>
                  </button>

                  <button v-else @click.prevent="setPage(currPage + 1)">
                    Next
                    <i class="material-icons">keyboard_arrow_right</i>
                  </button>
                </div>

                <!--
          <p class="mtauto" v-if="search.length">Results are being filtered</p>
          <p class="mtauto" v-else>Page {{currPage}} of {{ totalPage }} </p>
          <div class="nav-btns">

              <button v-if="this.currPage === 1" disabled><i class="material-icons">keyboard_arrow_left</i> Back</button>

              <button v-else @click.prevent="setPage(currPage-1)"><i class="material-icons">keyboard_arrow_left</i> Back</button>

              <button v-if="this.currPage === this.totalPage" disabled>Next <i class="material-icons">keyboard_arrow_right</i></button>

              <button v-else @click.prevent="setPage(currPage+1)">Next <i class="material-icons">keyboard_arrow_right</i></button>

          </div>
              --></div>
            </div>
          </div>
          <!-- end other column -->
        </div>
      </div>
      <!-- container -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
// import Avatar from "vue-avatar";
// import Datepicker from "vuejs-datepicker";
import VueDatePicker from '@vuepic/vue-datepicker';
import rgaTour from "../components/Tours/rgaTour.vue";

const auth = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
    //Authorization: "Bearer " + wontworkqwd2iwedjqoewiudwo
  },
};

export default {
  name: "RGAs",
  components: {
    AtomSpinner,
    // Avatar,
    // Datepicker,
    VueDatePicker,
    rgaTour,
  },
  data() {
    return {
      ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
      backend: import.meta.env.VITE_APP_SERVER_URL,
      searchValue: "",
      search: "",
      storedListings: [],
      searchRender: false,
      startDate: null,
      endDate: null,
      searchStarted: false,
      acs: [],
      rgas: [],
      selectedCat: "Show All",
      acFilter: null,
      searching: false,
      loading: true,
      countOfPage: 100,
      currPage: 1,
      noRGAFound: false,
      forumCats: [
        { id: 0, name: "Show All" },
        { id: 1, name: "Configura" },
        { id: 2, name: "Marketing" },
        { id: 3, name: "Other" },
        { id: 4, name: "Process" },
        { id: 5, name: "Product" },
        { id: 6, name: "Spacenet" },
      ],
      colSort: false,
      columnSort: "",
      rgaColumns: [
        { key: "rgaid",           label: "ID",        cls: "ten" },
        { key: "orderNo",         label: "Order #",   cls: "twenty" },
        { key: "acName",          label: "AC",        cls: "thirty" },
        { key: "requestedByUser", label: "Requester", cls: "twenty" },
        { key: "submitDate",      label: "Submitted", cls: "ten" },
        { key: "status",          label: "Status",    cls: "ten" },
      ],
    };
  },
  methods: {
    firstLoad: function () {
      this.loading = true;
      this.searchValue = "";
      this.startDate = null;
      this.acFilter = null;
      this.endDate = null;
      this.searchStarted = false;
      this.$store.commit("setActivePage", "order-manage");
      this.acListSync();
      //return axios.get(this.endPointCompute, auth).then((response) => {
      return axios.get(`${this.ordermanageapi}/rga/`, auth).then((response) => {
        //console.log(response);
        this.rgas = response.data;
        this.loading = false;
      });
    },

    acListSync: function () {
      //this.loading = true;

      if (!this.$store.state.acList.acList.length) {
        //console.log("getting acList");
        return axios
          .get(`${this.ordermanageapi}/aclist?active=true`, auth)
          .then((response) => {
            //console.log(response);
            const data = response.data;
            /*

            const low = data.filter(function (e) {
              return e.acid < 210;
            });

            const mid = data.filter(function (e) {
              return e.acid == 80069;
            });

            const high = data.filter(function (e) {
              return e.acid > 800000 && e.acid < 800250;
            });

            const all = low.concat(high).concat(mid);
            const alph = all.sort((a, b) => (a.acName > b.acName ? 1 : -1));
            */

            const alph = data.sort((a, b) => (a.acName > b.acName ? 1 : -1));
            this.acs = alph;
            //this.loading = false;
            this.$store.commit("UPDATE_ACLIST", this.acs);
          });
      } else {
        //console.log("vuex has length");
        this.acs = this.$store.state.acList.acList;
        //this.loading = false;
      }
    },

    statusClass(status) {
      const s = (status || "").toLowerCase();
      if (s.startsWith("approv") || s.startsWith("accept") || s.startsWith("complete") || s.startsWith("closed") || s.startsWith("received")) return "is-approved";
      if (s.startsWith("den") || s.startsWith("reject") || s.startsWith("declin") || s.startsWith("cancel")) return "is-denied";
      return "is-pending";
    },

    toUpperCase: function (str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.toUpperCase();
      });
    },

    searchReset: function () {
      this.selectedCat = "Show All";
    },

    setPage: function (idx) {
      this.search = "";
      if (idx <= 0 || idx > this.totalPage) {
        return;
      }
      this.currPage = idx;
    },

    catSwitcher: function (catType) {
      //console.log(catType);
      let category = catType;
      //console.log(category);
      if (category !== "Show All") {
        this.selectedCat = category;
        this.search = "";
        //console.log(category);
      } else {
        this.selectedCat = "Show All";
      }
    },
    searchQuery(event) {
      this.searchStarted = true;
      if (this.searchStarted === true) {
        this.storedListings = this.rgas;
      }

      this.search = "";
      this.loading = true;
      this.searching = true;

      //console.log(event);

      //console.log(`${this.ordermanageapi}/orders?search=${this.searchValue}`);
      /*
			return axios;
				.get(`${this.ordermanageapi}/order?search=${this.searchValue}`, auth)
				.then((response) => {*/
      return axios.get(this.searchEndpointCompute, auth).then((response) => {
        this.rgas = response.data;
        //console.log(response);
        this.loading = false;
        this.searching = false;
      });
    },
    clearSearch() {
      if (this.searchStarted == true) {
        this.rgas = this.storedListings;
        this.searchStarted = false;
        this.searchRender = !this.searchRender;
      }

      //this.listings = this.storedListings;

      this.searchValue = "";
      this.startDate = null;
      this.acFilter = null;
      this.endDate = null;
      this.$forceUpdate();

      //this.$forceUpdate();
      //Vue.set(this.listings, this.storedListings);
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    sortCol: function (type) {
      this.columnSort = type;
      const COLUMN = type;
      console.log(COLUMN);
      if (this.colSort) {
        this.filteredRGAs.sort((a, b) => (a[COLUMN] > b[COLUMN] ? 1 : -1));
      } else {
        this.filteredRGAs.sort((a, b) => (a[COLUMN] < b[COLUMN] ? 1 : -1));
      }
      this.colSort = !this.colSort;
    },
  },
  computed: {
    activeNav() {
      return this.$store.state.activePage;
    },

    showButton() {
      if (this.searchValue.trim().length > 0 || this.acFilter || this.startDate || this.endDate) {
        // console.log('true')
        return true;
      } else {
        // console.log('false')
        return false;
      }
    },

    colorGetter() {
      return this.$store.state.colors;
    },

    filteredRGAs: function () {
      //set the current page to 0
      this.currPage = 1;
      //if the search box is filled in
      if (this.search.trim() !== "") {
        return this.rgas.filter((e) => {
          //filter the subject line by what is filled in the search box
          return (
            e.OrderNumber.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          );
        });
      } else if (this.selectedCat !== "Show All") {
        this.search = "";
        //console.log(this.selectedCat);
        return this.rgas.filter((f) => {
          return f.Type == this.selectedCat;
        });
      } else {
        return this.rgas;
      }
    },

    foundNoRGA: function () {
      if (this.search.length > 1 && this.filteredRGAs.length === 0) {
        //this.noUserFound = true;
        return true;
      }
    },

    pageStart: function () {
      return (this.currPage - 1) * this.countOfPage;
    },

    totalPage: function () {
      return Math.ceil(this.rgas.length / this.countOfPage);
    },
    listingRestore: function () {
      if (
        !this.searchValue &&
        !this.loading &&
        !this.searching &&
        this.storedListings.length >= this.rfrs
      ) {
        //console.log("fired off");
        this.rfrs = this.storedListings;
      }
      return;
    },
    searchEndpointCompute: function () {
      //has order number, no start, no end, no ac
      if (
        this.searchValue.length &&
        !this.startDate &&
        !this.endDate &&
        !this.acFilter
      ) {
        console.log('1')
        return `${this.ordermanageapi}/rga?search=${this.searchValue.trim()}`;
      } else if (
        //has order number, and start, no end, no ac
        this.searchValue.length &&
        this.startDate != null &&
        this.endDate === null &&
        this.acFilter === null
      ) {
        console.log('2')
        return `${this.ordermanageapi}/rga?search=${
          this.searchValue.trim()
        }&start=${this.formatDate(this.startDate)}`;
      } else if (
        //has order number, and end, no start, no ac
        this.searchValue.length &&
        this.startDate === null &&
        this.acFilter === null &&
        this.endDate != null
      ) {
        console.log('3')
        return `${this.ordermanageapi}/rga?search=${
          this.searchValue.trim()
        }&end=${this.formatDate(this.endDate)}`;
      } else if (
        // has three, no ac
        this.searchValue.length &&
        this.startDate != null &&
        this.acFilter === null &&
        this.endDate != null
      ) {
        console.log('4')
        return `${this.ordermanageapi}/rga?search=${
          this.searchValue.trim()
        }&start=${this.formatDate(this.startDate)}&end=${this.formatDate(
          this.endDate
        )}`;
      } else if (
        //only has end
        !this.searchValue &&
        this.startDate === null &&
        this.endDate != null  &&
        this.acFilter === null
      ) {
        console.log('5')
        return `${this.ordermanageapi}/rga?end=${this.formatDate(
          this.endDate
        )}`;
      } else if (
        //only has start
        !this.searchValue &&
        this.startDate != null &&
        this.endDate === null &&
        this.acFilter === null
      ) {
        console.log('6')
        return `${this.ordermanageapi}/rga?start=${this.formatDate(this.startDate)}`;
      } else if (
        //has ac, start and end
        !this.searchValue &&
        this.startDate != null &&
        this.endDate != null && 
        this.acFilter !== null
      ) {
        console.log('7')
        return `${this.ordermanageapi}/rga?ac=${this.acFilter}&start=${this.formatDate(
          this.startDate
        )}&end=${this.formatDate(this.endDate)}`;
      } else if (
        //has all 4
        this.searchValue.length &&
        this.startDate != null &&
        this.acFilter != null &&
        this.endDate != null
      ) {
        console.log('8')
        return `${this.ordermanageapi}/rga?ac=${this.acFilter}&start=${this.formatDate(
          this.startDate
        )}&end=${this.formatDate(this.endDate)}&search=${
          this.searchValue.trim()
        }`;
      } else if (
        //has only ac
        !this.searchValue &&
        this.startDate === null &&
        this.endDate === null &&
        this.acFilter != null
      ) {
        console.log('9')
        return `${this.ordermanageapi}/rga?ac=${this.acFilter}`;
      } else if (
        //has ac and start
        !this.searchValue &&
        this.startDate != null &&
        this.acFilter != null &&
        this.endDate === null
      ) {
        console.log('10')
        return `${this.ordermanageapi}/rga?start=${this.formatDate(
          this.startDate
        )}&ac=${this.acFilter}`;
      } else if (
        //has ac and end
        !this.searchValue &&
        this.startDate === null &&
        this.acFilter != null &&
        this.endDate != null
      ) {
        console.log('11')
        return `${this.ordermanageapi}/rga?ac=${this.acFilter}&end=${this.formatDate(
          this.endDate
        )}`;
      } else if (
        //has ac and number
        this.searchValue.length &&
        this.startDate === null &&
        this.acFilter != null &&
        this.endDate === null
      ) {
        console.log('12')
        return `${this.ordermanageapi}/rga?search=${this.searchValue.trim()}&ac=${this.acFilter}`;
      } else if (
        //has ac and start and end
        !this.searchValue &&
        this.startDate != null &&
        this.acFilter != null &&
        this.endDate != null
      ) {
        console.log('13')
        return `${this.ordermanageapi}/rga?ac=${
          this.acFilter
        }&start=${this.formatDate(this.startDate)}&end=${this.formatDate(
          this.endDate
        )}`;
      } else if (
        //start and end
        !this.searchValue &&
        this.startDate != null &&
        this.acFilter === null &&
        this.endDate != null
      ) {
        console.log('14')
        return `${this.ordermanageapi}/rga?start=${this.formatDate(this.startDate)}&end=${this.formatDate(
          this.endDate
        )}`;
      } else if (
        //has ac, search and start
        this.searchValue.length &&
        this.startDate != null &&
        this.acFilter != null &&
        this.endDate === null
      ) {
        console.log('15')
        return `${this.ordermanageapi}/rga?ac=${
          this.acFilter
        }&start=${this.formatDate(this.startDate)}&search=${this.searchValue.trim()}`;
      } else if (
        //has ac, search and end
        this.searchValue.length &&
        this.startDate === null &&
        this.acFilter != null &&
        this.endDate != null
      ) {
        console.log('16')
        return `${this.ordermanageapi}/rga?ac=${
          this.acFilter
        }&end=${this.formatDate(this.startDate)}&search=${this.searchValue.trim()}`;
      } else {
        console.log('17')
        return `${this.ordermanageapi}/rga`;
      }
    },
  },
  created() {
    this.$store.commit("showNavigation");
    // console.log(this.$route.path);
  },

  mounted() {
    this.firstLoad();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media all and (min-width: 992px) {
  .flex-box-wrap {
    height: 200px;
    padding: 150px 0 125px 0;
    margin: 0;
  }
}

@media all and (max-width: 991px) {
  .flex-box-wrap {
    height: 100px;
    padding: 75px 0 50px 0;
    margin: 0;
    justify-content: center;
    align-items: center;
  }
}

.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #00b4b4;
  border-color: #00b4b4;
}

.rga {
  background-color: #fff;
  line-height: 44px;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}
.top-wrap {
  display: flex;
  align-items: flex-start;
}
.rga-bottom {
  align-items: flex-end;
}
.rga-header {
  background: #fff;
  color: #575757;
  display: flex !important;
}
.small-lh {
  line-height: 1.4em;
}

.listing {
  overflow: scroll;
}

.listing {
  background-color: #fff;
  line-height: 1;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}

.table-responsive {
  display: table;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03) !important;
}
.table-bordered td,
.table-bordered th {
  border: 1px solid #e8e8e8 !important;
}
.badge-success {
  color: #fff;
  background-color: #4d5967;
  background-color: #1eb5b6;
}
.table-striped a {
  color: #00b4b4;
}
.table-striped td,
.table-striped th {
  padding: 5px;
  font-weight: 300 !important;
}
.listing {
  border-radius: 4px;
}
table td {
  line-height: 1;
}
.table-striped th {
  background: #00b4b4;
  background: #4d5967;
  color: #fff;
}
.table-striped {
  min-width: 100%;
  overflow: scroll;
}
.search-btns {
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
}
.search-btns button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: #4d5967;
  color: #fff;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  max-height: 40px;
  padding: 23px 10px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.search-btns .clear {
  margin-right: 0;
  margin-left: auto;
  padding: 23px 15px;
}
.search-btns .search {
  /*margin-left: auto;*/
  margin-right: 0;
  margin-left: auto;
}
.search-btns button span {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #fff;
}
.search-btns button:hover {
  background: #586575;
}
.search-btns button:active {
  background: #586575;
}
.search-btns button:disabled {
  opacity: 0.6;
  cursor: unset !important;
}
.search-btns button:disabled:hover {
  background: #4d5967;
}
.search-btns button:disabled:active {
  background: #4d5967;
}

@media all and (min-width: 768px) {
  .dates {
    display: flex;
    color: #757575 !important;
  }
}
.top-search {
  color: #757575;
}
select.form-control:not([size]):not([multiple]) {
  height: auto !important;
  padding: 10px !important;
  color: #757575;
}
.all-contractors {
  color: #757575 !important;
}
@media all and (max-width: 991px) {
  /*
  .listing {
    overflow: scroll;
  }
  */
  table {
    width: 900px !important;
    overflow: scroll;
  }
}
.clear-btn {
  position: absolute;
  right: 0;
  top: 14px;
  border: none;
  background: none;
}
.clear-hide {
  display: none !important;
}
.input-wrap {
  position: relative;
  display: block;
}
.pixelsbggrid {
  background-color: #475059;
  background-size: cover;
  background-position: center;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200' preserveAspectRatio='xMidYMid slice'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%2356626d'/%3E%3Cstop offset='1' stop-color='%2356626d' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%2337778a'/%3E%3Cstop offset='1' stop-color='%2337778a' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%232b5c60'/%3E%3Cstop offset='1' stop-color='%232b5c60' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23667787'/%3E%3Cstop offset='1' stop-color='%23667787' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%231a8182'/%3E%3Cstop offset='1' stop-color='%231a8182' stop-opacity='0'/%3E%3C/radialGradient%3E%3ClinearGradient id='base' x1='0' y1='0' x2='1' y2='1'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='.5' stop-color='%2356626d'/%3E%3Cstop offset='1' stop-color='%231a8182'/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect fill='%23475059' width='1950' height='1200'/%3E%3Crect fill='url(%23base)' width='1950' height='1200'/%3E%3Cline x1='0' y1='0' x2='0' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='50' y1='0' x2='50' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='100' y1='0' x2='100' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='150' y1='0' x2='150' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='200' y1='0' x2='200' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='250' y1='0' x2='250' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='300' y1='0' x2='300' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='350' y1='0' x2='350' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='400' y1='0' x2='400' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='450' y1='0' x2='450' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='500' y1='0' x2='500' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='550' y1='0' x2='550' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='600' y1='0' x2='600' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='650' y1='0' x2='650' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='700' y1='0' x2='700' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='750' y1='0' x2='750' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='800' y1='0' x2='800' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='850' y1='0' x2='850' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='900' y1='0' x2='900' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='950' y1='0' x2='950' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1000' y1='0' x2='1000' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='1050' y1='0' x2='1050' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1100' y1='0' x2='1100' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1150' y1='0' x2='1150' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1200' y1='0' x2='1200' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1250' y1='0' x2='1250' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='1300' y1='0' x2='1300' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1350' y1='0' x2='1350' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1400' y1='0' x2='1400' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1450' y1='0' x2='1450' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1500' y1='0' x2='1500' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='1550' y1='0' x2='1550' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1600' y1='0' x2='1600' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1650' y1='0' x2='1650' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1700' y1='0' x2='1700' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1750' y1='0' x2='1750' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='1800' y1='0' x2='1800' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1850' y1='0' x2='1850' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1900' y1='0' x2='1900' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='0' x2='1950' y2='0' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='0' y1='50' x2='1950' y2='50' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='100' x2='1950' y2='100' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='150' x2='1950' y2='150' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='200' x2='1950' y2='200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='250' x2='1950' y2='250' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='0' y1='300' x2='1950' y2='300' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='350' x2='1950' y2='350' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='400' x2='1950' y2='400' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='450' x2='1950' y2='450' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='500' x2='1950' y2='500' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='0' y1='550' x2='1950' y2='550' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='600' x2='1950' y2='600' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='650' x2='1950' y2='650' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='700' x2='1950' y2='700' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='750' x2='1950' y2='750' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='0' y1='800' x2='1950' y2='800' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='850' x2='1950' y2='850' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='900' x2='1950' y2='900' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='950' x2='1950' y2='950' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='1000' x2='1950' y2='1000' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='0' y1='1050' x2='1950' y2='1050' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='1100' x2='1950' y2='1100' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='1150' x2='1950' y2='1150' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cg fill-opacity='0.45'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
}
/* ---------- Table typography ---------- */
.listing table { font-size: 14px; color: #2f3640; font-variant-numeric: tabular-nums; }

.table-striped th {
  background: #4d5967;
  color: #fff;
  font-size: 12px;
  font-weight: 600 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  line-height: 1.2;
  padding: 10px;
  white-space: nowrap;
  vertical-align: middle;
}
.th-inner { display: flex; align-items: center; justify-content: space-between; gap: 6px; }

.table-striped td {
  padding: 10px;
  line-height: 1.35;
  font-weight: 400 !important;
  vertical-align: middle;
}

/* Column roles */
.table-striped td.id a { color: #4d5967; font-weight: 400; text-decoration: none; }
.table-striped td.order a { color: #00797d; font-weight: 400; text-decoration: none; }
.table-striped td a:hover { text-decoration: underline; }
.table-striped td.ac { color: #1f2933; }
.table-striped .acid { color: #8a9099; margin-left: 4px; }
.table-striped td.person { color: #4d5967; }
.table-striped td.date { white-space: nowrap; color: #4d5967; }
.table-striped .muted { color: #a0a6ad; }

/* Status pill */
.status-pill {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
}
.is-approved { background: #eceef1; color: #4d5967; }
.is-denied   { background: #eceef1; color: #4d5967;}
.is-pending  { background: #eceef1; color: #4d5967; }

/* Sort icons */
.carrot-icon { font-size: 16px; opacity: 0.45; vertical-align: middle; }
.carrot-icon-active { opacity: 1; }

.table-striped tbody tr:nth-of-type(odd) {
   background-color: rgb(241 246 249 / 60%) !important
}
</style>
